import React, { useRef } from "react";
import { motion, useInView, useReducedMotion } from "framer-motion";
import LiveProofChat from "./LiveProofChat.jsx";
import {
  LIVE_PROOF_HEADLINE,
  LIVE_PROOF_PRIVACY_NOTE,
  LIVE_PROOF_STATS,
  LIVE_PROOF_STAMP,
  LIVE_PROOF_SUBHEAD,
  LIVE_PROOF_TAG,
} from "./liveProofContent.js";

const LiveProofSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-80px" });
  const reduceMotion = useReducedMotion();

  return (
    <section
      id="live-proof"
      className="cursor-section cursor-live-proof-section"
      data-testid="live-proof-section"
      ref={ref}
    >
      <div className="cursor-live-proof-inner">
        <div className="cursor-live-proof-grid">
          <motion.div
            className="cursor-live-proof-copy-col"
            initial={reduceMotion ? false : { opacity: 0, y: 16 }}
            animate={reduceMotion || isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 16 }}
            transition={{ duration: 0.45, ease: "easeOut" }}
          >
            <div className="cursor-live-proof-stamp-row">
              <span className="cursor-live-proof-stamp">{LIVE_PROOF_STAMP}</span>
              <span className="cursor-live-proof-tag">{LIVE_PROOF_TAG}</span>
            </div>

            <h2 className="cursor-live-proof-headline" data-testid="live-proof-headline">
              {LIVE_PROOF_HEADLINE.lead}{" "}
              <span className="cursor-live-proof-headline-accent">
                {LIVE_PROOF_HEADLINE.accentPrimary}
              </span>{" "}
              {LIVE_PROOF_HEADLINE.leadMid}{" "}
              <span className="cursor-live-proof-headline-accent">
                {LIVE_PROOF_HEADLINE.accentSecondary}
              </span>
            </h2>

            <div className="cursor-live-proof-stats" data-testid="live-proof-stats">
              {LIVE_PROOF_STATS.map((stat) => (
                <div key={stat.label} className="cursor-live-proof-stat">
                  <div className="cursor-live-proof-stat-value">{stat.value}</div>
                  <div className="cursor-live-proof-stat-label">{stat.label}</div>
                  <div className="cursor-live-proof-stat-sub">{stat.sub}</div>
                </div>
              ))}
            </div>

            <p className="cursor-live-proof-subhead">{LIVE_PROOF_SUBHEAD}</p>
          </motion.div>

          <motion.div
            className="cursor-live-proof-phone-col"
            initial={reduceMotion ? false : { opacity: 0, y: 16 }}
            animate={reduceMotion || isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 16 }}
            transition={{ duration: 0.45, delay: 0.1, ease: "easeOut" }}
          >
            <LiveProofChat />
            <p className="cursor-live-proof-privacy-footer" data-testid="live-proof-privacy">
              <span aria-hidden="true">🔒 </span>
              {LIVE_PROOF_PRIVACY_NOTE}
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default LiveProofSection;
